import { render, staticRenderFns } from "./profit-loss-print.vue?vue&type=template&id=33b399ba&scoped=true"
import script from "./profit-loss-print.vue?vue&type=script&lang=js"
export * from "./profit-loss-print.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b399ba",
  null
  
)

export default component.exports